module.exports = __webpack_public_path__ + "static/media/phone.7b65a015.png";